export class NextivaService {
  private static readonly hiddenStyleId = "nextiva-chat-hidden";
  private static readonly hiddenClass = "nextiva-chat-hidden";
  private static readonly scriptId = "nextiva-chat-script";

  public static async SetupChatClient() {
    if (document.getElementById(NextivaService.scriptId) !== null) {
      return;
    }

    (window as any).thrioParams = {
      host: "nextiva.thrio.io",
      tenantId: "3570390",
      campaignId: "69864127f1e80438c99ad9b2",
      trace: false,
      context: {},
    };

    let nextivaScript = document.createElement("script");
    nextivaScript.id = NextivaService.scriptId;
    nextivaScript.setAttribute("type", "module");
    nextivaScript.setAttribute("src", "https://storage.googleapis.com/thrio-public-prod-files/thriowidgets-1.4.3.js");

    document.head.appendChild(nextivaScript);
  }

  public static SetChatClientVisibility(isVisible: boolean) {
    if (isVisible) {
      document.documentElement.classList.remove(NextivaService.hiddenClass);
      return;
    }

    document.documentElement.classList.add(NextivaService.hiddenClass);

    if (document.getElementById(NextivaService.hiddenStyleId) === null) {
      const style = document.createElement("style");
      style.id = NextivaService.hiddenStyleId;
      style.textContent = `
        html.${NextivaService.hiddenClass} body #chat-notification,
        html.${NextivaService.hiddenClass} body #initializeriframe,
        html.${NextivaService.hiddenClass} body #idSurveyContainer,
        html.${NextivaService.hiddenClass} body .th-bottom-button,
        html.${NextivaService.hiddenClass} body iframe[src*="nextiva.thrio.io"],
        html.${NextivaService.hiddenClass} body iframe[src*="thrio.io"] {
          display: none !important;
        }
      `;
      document.head.appendChild(style);
    }
  }
}
